import styled from "styled-components";
import config from "../../../Config/config.json";
import Theme from "../../../Styles/Themes/index.js";
import { GetColors } from "../../../util/Colors.js";
import SVG from "react-inlinesvg";

export const Container = styled.main`
    display: flex;
    flex-direction: column;
    margin-top: 75px;
    width: -webkit-fill-available;

    @media (min-width: 720px) {
        margin: 20px 0 0 176px;
    }
    @media (orientation: landscape) and (max-width: 1200px){
        margin: 75px 0 0 0;
    }
`;

export const FullHeader = styled.div`
    align-items: center;
    display: flex;
    flex-direction: column;
    gap: 10px;
    justify-content: center;
    @media (min-width: 720px) {
        align-items: start;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        justify-content: space-between;
        padding-right: 80px;
    } 

    .header{
        align-items: flex-start;
        display: flex;
        justify-content: space-between;
        width: 100%;
    }
`;

export const HeaderLeft = styled.ul`
    align-items: center;
    display: flex;
    flex-direction: column;
    gap: 10px;
    justify-content: space-around;
    padding: 0 20px 20px 0;
    @media (min-width: 720px) {
        display: flex;
    }
    @media (min-width: 1080px) {
        align-items: flex-start;
        width: 70%;
    }
`;

export const HeaderContainer = styled.div`
    align-items: center;
    display: flex;
    flex-direction: column;
    gap: 10px;
    justify-content: space-around;
    padding: 20px;
    @media (min-width: 720px) {
        display: flex;
        flex-direction: row;
        height: 180px;
        padding: 20px 20px 20px 0px;
    }
`;

export const HeaderRight = styled.div`
    align-items: center;
    display: flex;
    flex-direction: column;
    gap: 10px;
    justify-content: space-around;
    padding: 20px 0;
    @media (min-width: 720px) {
        display: flex;

    }
`;

export const HeaderContainerList = styled.li`
    align-items: center;
    display: flex;
    flex-direction: column;
    gap: 10px;
    justify-content: flex-start;
    list-style: none;
    padding: 20px 0px;
    width: 100%;

    @media (min-width: 1080px) {
        border : 0px;
        display: flex;
        flex-direction: row;
        width: 100%;
    }
`;

export const DateContainer = styled.div`
    align-items: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 300px;

    .custom-input {
        &:hover {
            background-color: #F2F2F2;
            border-color: #33CC99;
        }
    }
`;

export const BodyContainer = styled.div`
    display: flex;
    flex-direction: column;
    padding: 25px;
`;

export const ContainerTable = styled.div`
    display: flex;
    flex-direction: column;
    overflow: auto;
    width: 100%;
`

export const Table = styled.table`
    border: 0px; 
    border-collapse: separate;
    border-spacing: 0px 10px;
    width: 100%;
`;

export const TableHeader = styled.th`
    border: 0px; 
    color: #333;
    font-weight: 900;
    padding: 8px;
    text-align: center;
`;

export const TableRow = styled.tr`
    border: 0px; 
`;

export const TableCell = styled.td`
    border: 1px solid #ddd;
    border: 0px; 
    padding: 8px;
`;

export const TableCellItem = styled.span`
    align-items: center;
    background: ${({ $alarm }) => {return (
        $alarm === 0 ? '#BBEBD5' :
        $alarm === 1 ? '#F8FFCC' : 
        $alarm === 2 ? '#FFCCD5' :
        '#fff')
    }};
    border: 1px solid black;
    border-radius: 5px;
    color: black;
    display: flex;
    height: 100%;
    justify-content: center;
    margin: 0 0 0 10px;
    padding: 0 0;
    padding-inline: 5px;
    text-align: center;
    white-space: nowrap;
`;

export const GraphContainer = styled.div`
    align-items: center;
    background: #f2f2f2;
    border-radius: 15px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-block: 15px;
    width: 100%;
`;

export const NoData = styled.span`
    color: #333;
    font-size: 24px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
`;

export const Icon = styled(SVG)`
    height: 30px;
    width: 30px;
    & path {
        fill: ${({$disabled}) => $disabled ? '#A3A3A3' : '#006560'};
    }
`;

export const DownloadiconContainer = styled(SVG)`
    align-self: center;
    height: 30px;
    width: 30px;
    & path {
        fill: ${({ fill }) => fill};
    }
`;

export const ButtonDownload = styled.button`
    align-items: center;
    align-self: center;
    background: ${props=> props.$color ? GetColors(props.$color).background : Theme[config.theme].colors.buttonBackground};
    border: ${props=> props.$color ? GetColors(props.$color).border : 'none'};
    border-radius: 10px;
    color: ${props=> props.$color ? GetColors(props.$color).color : Theme[config.theme].colors.secondaryFontColor};
    cursor: pointer;
    display: flex;
    font-size: ${Theme[config.theme].font.labels[config.fontSize].size};
    font-weight: ${Theme[config.theme].font.labels[config.fontSize].weight};
    gap: 10px;
    height: fit-content;
    justify-content: center;
    line-height: ${Theme[config.theme].font.labels[config.fontSize].line_height};
    padding: 20px 20px 20px 20px;
    width: ${props => props.$width};
    &:hover {
        background: ${props=> props.$color ? GetColors(props.$color).hoverbg : Theme[config.theme].colors.buttonBackgroundHover};
        color: ${props=> props.$color ? GetColors(props.$color).hovercolor : Theme[config.theme].colors.secondaryFontColor};
    }
    &:focus {
        ${props=> props.$color ? GetColors(props.$color).background :  'background:' + Theme[config.theme].colors.buttonBackgroundFocus};
    }
    &:disabled{
        background: #A3A3A3;
    }
`;

export const GraphTitle = styled.span`
    color: #333;
    font-size: 24px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
`;

export const ContainerCheckbox = styled.form`
    align-items: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-top: 20px;
    width: 100%;
`;

export const LegendContainer = styled.div`
    align-items: start;
    display: flex;
    flex-direction: column;
    gap: 15px;
    justify-content: space-between;
    margin-block: 10px;
    margin-top: 5px;
    width: 100%;
`;

export const ConfigContainer = styled.div`
    align-items: center;
    display: flex;
    flex-direction: row;
    gap: 25px;
    justify-content: flex-end;
    width: 100%;
    @media (min-width: 720px) {
        padding-right: 60px;
    }
`;

export const ContainerRow = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-block: 10px;
    overflow: auto;
    width: 100%;
`;

export const ContainerColumn = styled.div`
    align-items: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-block: 10px;
    width: 100%;
`;

export const NumberInput = styled.input`
    align-items: center;
    background: #FFF;
    border: 1.14px solid #C4C4C4;
    border-radius: 3.802px;
    box-shadow: 1.52061px 1.52061px 3.80152px 0px rgba(0, 0, 0, 0.40) inset;
    color: #333;
    display: flex;
    font-size: 15px;
    font-weight: 600; 
    font-style: normal;
    height: 24px;
    justify-content: center;
    line-height: 0;
    outline: none;
    text-align: center;
    width: 48px;
    &::-webkit-inner-spin-button{
        -webkit-appearance: none;
    }
`;

export const Text = styled.h1`
    color: #333;
    font-size: 15px;
    font-style: normal;
    font-weight: 400;
    max-width: 100%;
    overflow: auto;
    text-align: left;
    white-space: nowrap;
    &::-webkit-scrollbar {
        height : 3px;
    }
    &::-webkit-scrollbar-thumb {
        background-color: #ccc;
        border-radius: 5px;
    }
    &::-webkit-scrollbar-thumb:hover {
        background-color: #aaa
    }
    &::-webkit-scrollbar-track {
        background: transparent;
    }
    &::-webkit-scrollbar-button {
        display: none;
    }
`;

export const ScaleText = styled.h1`
    color: #333;
    font-size: 15px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    text-align: center;
    white-space: nowrap;
`;

export const EquipamentScale = styled.h1`
    color: #333;
    font-size: 15px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
`

export const ContainerVariaveis = styled.div`
    background: #F2F2F2;
    border-radius: 10px;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    margin-block: 10px;
    overflow: auto;
    padding: 10px;
    width: 100%;
`;

export const ContainerVariaveisItem = styled.div`
    background: #FFF;
    display: flex;
    width: 50%;
`;

export const ContainerScale = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 10px;
    margin-block: 10px;
`;

export const ButtonContainer = styled.div`
    align-items: center;
    display: flex;
    gap: 10px;
    justify-content: center;
    margin-block: 10px;
`;

export const LegendWrap = styled.div`
    align-items: center;
    border-radius: 10px;
    display: flex;
    flex-direction: row;
    gap: 10px;
    padding: 10px;
`;

export const WrapContainer = styled.div`
    align-items: center;
    background: #FFF;
    border-radius: 10px;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 10px;
    padding: 5px;
`